import React from 'react';

import { UiKit } from 'components';
import * as DefaultReturnWindow from './DefaultReturnWindow';
import * as ProductReturnWindows from './ProductReturnWindows';
import { FeatureContainer } from '../../components';
import { useFTUWizard } from '../../context';

export default function ReturnWindow() {
  const { onGotoNext } = useFTUWizard();

  return (
    <FeatureContainer
      title="What is your return window?"
      subtitle="Select the amount of time your customers are allowed to return and exchange the products. This time frame is applied after the date of delivery."
    >
      <UiKit.Flex direction="column" gap={24}>
        <DefaultReturnWindow.Provider>
          <UiKit.Sheet.ActionsPortal>
            <DefaultReturnWindow.SaveButton onDone={onGotoNext} />
          </UiKit.Sheet.ActionsPortal>
        </DefaultReturnWindow.Provider>

        <UiKit.Card>
          <UiKit.Card.Header
            title="Custom return windows (Optional)"
            description="Set custom return windows for specific products or types."
          />
          <UiKit.Card.Body>
            <ProductReturnWindows.Provider>
              <ProductReturnWindows.List />
            </ProductReturnWindows.Provider>
          </UiKit.Card.Body>
        </UiKit.Card>
      </UiKit.Flex>
    </FeatureContainer>
  );
}
